import { PageNavItem, PageConfig, CommonPageId, IconName } from '@mental-mint/shared-ui';

export const CraftegoryPageId = {
  Play: 'craftegory-play',
  PuzzleIntro: 'craftegory-puzzle-intro',
  Victory: 'craftegory-victory',
} as const;

export type CraftegoryPageId = typeof CraftegoryPageId[keyof typeof CraftegoryPageId];

const craftegoryNavConfig: Record<string, PageNavItem> = {
  [CraftegoryPageId.PuzzleIntro]: {
    label: 'How to Play',
    icon: IconName.HelpCircle,
    order: 1,
  },
  [CommonPageId.More]: {
    label: 'More',
    icon: IconName.MoreHorizontal,
    order: 2,
  },
};

export const craftegoryPageConfig: Record<string, PageConfig> = {
  [CraftegoryPageId.Play]: {
    id: CraftegoryPageId.Play,
    navItem: null,
  },
  [CraftegoryPageId.PuzzleIntro]: {
    id: CraftegoryPageId.PuzzleIntro,
    modalPageConfig: {
      humanReadableTitle: 'How to Play',
    },
    navItem: craftegoryNavConfig[CraftegoryPageId.PuzzleIntro],
  },
  [CraftegoryPageId.Victory]: {
    id: CraftegoryPageId.Victory,
    modalPageConfig: {
      humanReadableTitle: '',
    },
    navItem: null,
  },
  [CommonPageId.More]: {
    id: CommonPageId.More,
    modalPageConfig: {
      humanReadableTitle: 'More Games',
    },
    navItem: craftegoryNavConfig[CommonPageId.More],
  },
};
